import { axiosInstance } from "../instance"

export const GET_TARIFF_LIST = () => axiosInstance.get("/tariffs")

export const GET_SINGLE_TARIFF = id => axiosInstance.get(`/tariffs/${id}`)
